import { useEffect } from 'react';

let headerTitleCallback = null;
let showBackButtonCallback = null;
let customBackHandler = null;

export const setHeaderTitleCallback = (callback) => {
	headerTitleCallback = callback;
};

export const setShowBackButtonCallback = (callback) => {
	showBackButtonCallback = callback;
};

export const setCustomBackHandler = (handler) => {
	customBackHandler = handler;
};

export const getCustomBackHandler = () => {
	return customBackHandler;
};

export const useHeaderTitle = (title, showBackButton = false) => {
	useEffect(() => {
		if (headerTitleCallback && title) {
			headerTitleCallback(title);
		}
		if (showBackButtonCallback !== null) {
			showBackButtonCallback(showBackButton);
		}

		// Cleanup: reset title and back button when component unmounts
		return () => {
			if (headerTitleCallback) {
				headerTitleCallback('金飯碗 Gold Rice Bowl');
			}
			if (showBackButtonCallback) {
				showBackButtonCallback(false);
			}
			if (customBackHandler) {
				customBackHandler = null;
			}
		};
	}, [title, showBackButton]);
};

export default useHeaderTitle;
